import * as React from "react";
import uniqBy from "lodash-es/uniqBy"
import MultiSelectModal, { GetQueryFilter } from "../../misc/components/queryTable/MultiSelectModal";
import { QueryCondition, Query, Subject, QueryFilter } from "../../misc/api/apiTypes";
import { SubjectGenderFilterMember } from "../SubjectsShared";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface GenderTableFilterProps {
    query: Query<Subject>;
    onClose: (filters: QueryFilter[]) => void;
    onClear: (member: string) => void;
}

export const GenderTableFilter = ({ query, onClose, onClear, }: GenderTableFilterProps): JSX.Element => {

    const condition = QueryCondition.Equal;
    const queryFilter = GetQueryFilter(query, SubjectGenderFilterMember, condition) || { Values: [] };
    const [values, setValues] = React.useState<string[]>(queryFilter.Values as string[]);
    const [allGenders, setAllGenders] = React.useState<any[]>([]);
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        legacyClient.getSubjects({}).then(result => {
            const unique = uniqBy(result.Data.filter(s => s.Gender), s => s.Gender.Id);
            setAllGenders(unique.map(g => ({ label: g.Gender.Name, value: g.Gender.Id })));
        });
    }, []);

    return (<MultiSelectModal
        header="Gender Filter"
        isLoading={!allGenders}
        show={true}
        options={allGenders}
        valueKey="value"
        labelKey="label"
        values={allGenders && allGenders.filter(o => values.includes(o.value))}
        onChange={(updatedValues: string[]) => {
            setValues(updatedValues.length > 0 ? updatedValues : null);
        }}
        onClose={() => {
            onClose([{ Member: SubjectGenderFilterMember, Condition: condition, Values: values }]);
        }}
        onClear={() => {
            onClear(SubjectGenderFilterMember);
        }}
    />)
}
